module.exports = __webpack_public_path__ + "static/media/iconArrow.4a1a9c4c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/iconArrow.svg
// module id = 283
// module chunks = 0